module.exports = __webpack_public_path__ + "static/media/BRB_sm2.33ff9f94.png";